var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "80px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "row-style": _vm.rowStyleFun,
        },
        on: {
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.customer.account"),
                          prop: "clientCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.newClientCode,
                            placeholder: _vm.$t(
                              "AccountManagement.customer.account"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.clientCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "clientCode", $$v)
                            },
                            expression: "queryParams.clientCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.customer.name"),
                          prop: "cusId",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.customerList,
                            placeholder: _vm.$t("customerNameText"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.cusId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "cusId", $$v)
                            },
                            expression: "queryParams.cusId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.customer.status"),
                          prop: "enabled",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_ENABLED_TRUE,
                            placeholder: _vm.$t(
                              "AccountManagement.customer.status"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "enabled", $$v)
                            },
                            expression: "queryParams.enabled",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.common.isfreeze"),
                          prop: "lock",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_FROZEN_TRUE,
                            placeholder: _vm.$t(
                              "AccountManagement.common.isfreeze"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.lock,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "lock", $$v)
                            },
                            expression: "queryParams.lock",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.common.isLeave"),
                          prop: "isDeparture",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_EXITED_USER,
                            placeholder: _vm.$t(
                              "AccountManagement.common.isLeave"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.isDeparture,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "isDeparture", $$v)
                            },
                            expression: "queryParams.isDeparture",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "DetailsOfThirdPartySalesOrder.employee"
                          ),
                          prop: "csgSales",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.csgSalesList,
                            placeholder: _vm.$t(
                              "DetailsOfThirdPartySalesOrder.employee"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.csgSales,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "csgSales", $$v)
                            },
                            expression: "queryParams.csgSales",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("workOrderList.Customer"),
                          prop: "csgCustomer",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.customerNameList,
                            placeholder: _vm.$t("workOrderList.Customer"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.csgCustomer,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "csgCustomer", $$v)
                            },
                            expression: "queryParams.csgCustomer",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "AccountManagementAdd.customerInfo.industry"
                          ),
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.industryList,
                            placeholder: _vm.$t(
                              "AccountManagementAdd.customerInfo.industry"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.industryList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "industryList", $$v)
                            },
                            expression: "queryParams.industryList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission:BusinessUserCustomerAddCSG",
                            arg: "BusinessUserCustomerAddCSG",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.addCustom },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("AccountManagement.common.NewCustom"))
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission:BusinessUserCustomerOffline",
                            arg: "BusinessUserCustomerOffline",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.letOffLine },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkLogoutText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop === "clientCode"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "realName"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "companyName"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "enabled"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(" " + _vm._s(col.label) + " "),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.table.disableTip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: row.enabled
                                            ? "success"
                                            : "info",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.STATUS_ENABLED_TRUE.bjGet(
                                                row.enabled
                                              )
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "locked"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(" " + _vm._s(col.label) + " "),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.table.lockTip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: row.locked ? "success" : "info",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.STATUS_YES_TRUE.bjGet(
                                                row.locked
                                              )
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "lock"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(" " + _vm._s(col.label) + " "),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.table.freezeTip"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    row.lock == null
                                      ? _c("span")
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: row.lock
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_TRUE.bjGet(
                                                    row.lock
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "isDeparture"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    row.isDeparture == null
                                      ? _c("span")
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: !row.isDeparture
                                                ? "success"
                                                : "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_EXITED_USER.bjGet(
                                                    row.isDeparture
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "protectEndTime"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "cusName"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "csgSales"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "csgCustomer"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "createdName"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "creationDate"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "startDateActive"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "industry"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "endDateActive"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: col.prop,
                            title: col.label,
                            "min-width": col.width || "auto",
                          },
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            "min-width": col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessUserCustomerEditCSG",
                                            arg: "BusinessUserCustomerEditCSG",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toPage(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "AccountManagement.common.edit"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        attrs: { size: "mini" },
                                        on: {
                                          command: function ($event) {
                                            return _vm.command(
                                              $event,
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "AccountManagement.common.operate"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            !scope.row.isDeparture
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessUserRolelndex_EditTwo",
                                                        arg: "BusinessUserRolelndex_EditTwo",
                                                      },
                                                    ],
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "AccountManagement.common.Info"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.Info"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "AccountManagement.common.Change"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.Change"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "WarehouseManagement.form.Shipping"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "WarehouseManagement.form.Shipping"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture &&
                                            !scope.row.enabled
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command:
                                                        _vm.$t("enableText"),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("enableText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture &&
                                            scope.row.enabled
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command:
                                                        _vm.$t("disableText"),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("disableText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture &&
                                            scope.row.enabled &&
                                            !scope.row.lock
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessUserRolelndex_Frozen",
                                                        arg: "BusinessUserRolelndex_Frozen",
                                                      },
                                                    ],
                                                    attrs: {
                                                      disabled:
                                                        _vm.lockDisabled(
                                                          scope.row
                                                        ),
                                                      command: _vm.$t(
                                                        "AccountManagement.common.freeze"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.freeze"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture &&
                                            scope.row.enabled &&
                                            scope.row.lock
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "permission",
                                                        rawName:
                                                          "v-permission:BusinessUserRolelndex_Frozen",
                                                        arg: "BusinessUserRolelndex_Frozen",
                                                      },
                                                    ],
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "AccountManagement.common.unfreeze"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.unfreeze"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture &&
                                            scope.row.enabled &&
                                            !scope.row.locked
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "AccountManagement.common.lock"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.lock"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture &&
                                            scope.row.enabled &&
                                            scope.row.locked
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "AccountManagement.common.deblocking"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.deblocking"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !scope.row.isDeparture
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "AccountManagement.common.Leave"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.Leave"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: _vm.$t(
                                                        "AccountManagement.common.Back"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "AccountManagement.common.Back"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                staticClass: "delete-btn",
                                                attrs: {
                                                  command: _vm.$t("delText"),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("delText"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.passDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                title: _vm.title,
                visible: _vm.passDialogVisible,
                width: "500px",
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.passDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "status-icon": "",
                    rules: _vm.rules,
                    "label-position": "top",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagement.common.password"),
                        prop: "pass",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: { autocomplete: "off", "show-password": "" },
                        model: {
                          value: _vm.form.pass,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pass", $$v)
                          },
                          expression: "form.pass",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountManagement.common.Confirm"),
                        prop: "checkPass",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: { autocomplete: "off", "show-password": "" },
                        model: {
                          value: _vm.form.checkPass,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "checkPass", $$v)
                          },
                          expression: "form.checkPass",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("dialog-company", {
        ref: "dialogCompany",
        on: { reFresh: _vm.reFresh },
      }),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogFormVisible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "quantity",
                    label:
                      _vm.$t("AccountManagement.common.termOfProtection") + ":",
                  },
                },
                [
                  _c("BjDatePicker", {
                    attrs: {
                      "picker-options": _vm.pickerOptions,
                      valueFormat: "yyyy-MM-dd 23:59:59",
                    },
                    model: {
                      value: _vm.lockForm.protectEndTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.lockForm, "protectEndTime", $$v)
                      },
                      expression: "lockForm.protectEndTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveProtectTime },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialogTrans", {
        ref: "dialogTransRef",
        on: { reFresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }